
export const footerData = [
    {
        title: "Quick Links",
        text: [
            {
                list: "Help Center",
                link: "/"
            },
            {
                list: "Contact Us",
                link: "/about"
            },
            {
                list: "How it works",
                link: "/services"
            },

            {
                list: "Delivery & Installation",
                link: "/header"
            },
            {
                list: "Track your vehicle",
                link: "/header"
            },
            {
                list: "Dispute Resolution",
                link: "/features"
            },

            {
                list: "Report a Product",
                link: "/testimonials"
            },

        ],
    },
    {
        title: "Useful Links",
        text: [
            {
                list: "Aboout Us",
                link: "/header"
            },
            {
                list: "Privacy Policy",
                link: "/features"
            },

            {
                list: "Terms & Conditions",
                link: "/testimonials"
            },

            {
                list: "Sell our Products",
                link: "/features"
            },

            {
                list: "Testimonials",
                link: "/testimonials"
            },

            {
                list: "Become an Affiliate Partner",
                link: "/videos"
            },
        ],
    },
];
